<template>
  <div class="m-msc-rewards">
    <h2 class="m-msc-rewards__title heading-h2">My Sisley Club法国希思黎致臻坊</h2>
    <p class="m-msc-rewards__subtitle heading-h4">查看您的会员信息</p>
    <!-- 基础信息 -->
    <div class="m-msc-rewards__points-wrapper">
      <div class="m-msc-rewards__points">
        <svg class="svg-inline msc-status msc-nostatus" aria-hidden="true" width="85" height="85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>My</title>
          <defs>
            <circle id="a" cx="42.5" cy="42.5" r="42.5"></circle>
          </defs>
          <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff">
              <use xlink:href="#a"></use>
            </mask>
            <use fill="#F4F4F4" xlink:href="#a"></use>
            <path d="M38.03 14.84c-1.68.093-2.905.28-3.675.56s-1.295.817-1.575 1.61c-.28.793-.42 2.077-.42 3.85v34.72c0 1.773.14 3.057.42 3.85.28.793.805 1.33 1.575 1.61.77.28 1.995.467 3.675.56V63c-2.147-.14-5.11-.21-8.89-.21-4.013 0-7 .07-8.96.21v-1.4c1.68-.093 2.905-.28 3.675-.56s1.295-.817 1.575-1.61c.28-.793.42-2.077.42-3.85V18.06L8.98 63.35H7.86L-9.78 17.92v36.96c0 1.82.152 3.173.455 4.06.303.887.898 1.528 1.785 1.925.887.397 2.263.642 4.13.735V63c-1.68-.14-4.06-.21-7.14-.21-2.8 0-4.97.07-6.51.21v-1.4c1.633-.093 2.847-.338 3.64-.735.793-.397 1.33-1.05 1.61-1.96.28-.91.42-2.252.42-4.025V20.86c0-1.773-.14-3.057-.42-3.85-.28-.793-.805-1.33-1.575-1.61-.77-.28-1.995-.467-3.675-.56v-1.4c1.54.14 3.71.21 6.51.21 2.427 0 4.41-.07 5.95-.21l15.4 40.53 15.05-40.32h3.29c3.78 0 6.743-.07 8.89-.21v1.4zm32.2 12.32c2.053 0 3.827-.07 5.32-.21v1.4c-.933.093-1.762.513-2.485 1.26-.723.747-1.412 1.96-2.065 3.64l-11.48 30.1-2.38 6.09c-.887 2.287-1.89 3.92-3.01 4.9-.7.653-1.54 1.12-2.52 1.4-.98.28-1.96.42-2.94.42-1.4 0-2.543-.373-3.43-1.12-.887-.747-1.33-1.773-1.33-3.08 0-1.12.327-2.018.98-2.695s1.563-1.015 2.73-1.015c1.027 0 1.878.292 2.555.875.677.583 1.015 1.388 1.015 2.415 0 1.4-.63 2.45-1.89 3.15.093.047.233.07.42.07 2.567 0 4.55-1.82 5.95-5.46l2.45-6.37-12.67-30.59c-.793-1.587-1.587-2.637-2.38-3.15-.793-.513-1.587-.77-2.38-.77v-1.47c2.007.28 4.293.42 6.86.42 2.333 0 5.367-.14 9.1-.42v1.47c-1.68 0-2.905.14-3.675.42-.77.28-1.155.957-1.155 2.03 0 .98.28 2.123.84 3.43l8.4 20.86 7.77-20.23c.513-1.4.77-2.473.77-3.22 0-1.073-.42-1.867-1.26-2.38-.84-.513-2.17-.84-3.99-.98v-1.4c2.473.14 4.433.21 5.88.21z" fill="#000" fill-rule="nonzero" mask="url(#b)"></path>
          </g>
        </svg>
        <p class="m-msc-rewards__points-description text--no-margin">
          您的会员身份：<span class="m-msc-rewards__points-description--nostatus">{{userFullInfo.customer_level}}</span>
        </p>
      </div>
      <!-- <p class="heading-h4">您有<span class="m-msc-rewards__points-amount">0分•</span>获得了0分</p> -->
      <p class="heading-h4">您的积分：<span class="m-msc-rewards__points-amount"> {{userFullInfo.total_points}} </span>分</p>
      <p class="m-msc-rewards__points-update text--no-margin">显示实际的积分需要24小时。</p>
    </div>
    <!-- 类似卡片 -->
    <div class="m-msc-rewards__status m-msc-rewards__status--nostatus">
      <svg class="svg-inline msc-status msc-nostatus" aria-hidden="true" width="85" height="85" viewBox="0 0 85 85" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>My</title>
        <defs><circle id="a" cx="42.5" cy="42.5" r="42.5"></circle></defs>
        <g fill="none" fill-rule="evenodd">
          <mask id="b" fill="#fff"><use xlink:href="#a"></use></mask>
          <use fill="#F4F4F4" xlink:href="#a"></use>
          <path d="M38.03 14.84c-1.68.093-2.905.28-3.675.56s-1.295.817-1.575 1.61c-.28.793-.42 2.077-.42 3.85v34.72c0 1.773.14 3.057.42 3.85.28.793.805 1.33 1.575 1.61.77.28 1.995.467 3.675.56V63c-2.147-.14-5.11-.21-8.89-.21-4.013 0-7 .07-8.96.21v-1.4c1.68-.093 2.905-.28 3.675-.56s1.295-.817 1.575-1.61c.28-.793.42-2.077.42-3.85V18.06L8.98 63.35H7.86L-9.78 17.92v36.96c0 1.82.152 3.173.455 4.06.303.887.898 1.528 1.785 1.925.887.397 2.263.642 4.13.735V63c-1.68-.14-4.06-.21-7.14-.21-2.8 0-4.97.07-6.51.21v-1.4c1.633-.093 2.847-.338 3.64-.735.793-.397 1.33-1.05 1.61-1.96.28-.91.42-2.252.42-4.025V20.86c0-1.773-.14-3.057-.42-3.85-.28-.793-.805-1.33-1.575-1.61-.77-.28-1.995-.467-3.675-.56v-1.4c1.54.14 3.71.21 6.51.21 2.427 0 4.41-.07 5.95-.21l15.4 40.53 15.05-40.32h3.29c3.78 0 6.743-.07 8.89-.21v1.4zm32.2 12.32c2.053 0 3.827-.07 5.32-.21v1.4c-.933.093-1.762.513-2.485 1.26-.723.747-1.412 1.96-2.065 3.64l-11.48 30.1-2.38 6.09c-.887 2.287-1.89 3.92-3.01 4.9-.7.653-1.54 1.12-2.52 1.4-.98.28-1.96.42-2.94.42-1.4 0-2.543-.373-3.43-1.12-.887-.747-1.33-1.773-1.33-3.08 0-1.12.327-2.018.98-2.695s1.563-1.015 2.73-1.015c1.027 0 1.878.292 2.555.875.677.583 1.015 1.388 1.015 2.415 0 1.4-.63 2.45-1.89 3.15.093.047.233.07.42.07 2.567 0 4.55-1.82 5.95-5.46l2.45-6.37-12.67-30.59c-.793-1.587-1.587-2.637-2.38-3.15-.793-.513-1.587-.77-2.38-.77v-1.47c2.007.28 4.293.42 6.86.42 2.333 0 5.367-.14 9.1-.42v1.47c-1.68 0-2.905.14-3.675.42-.77.28-1.155.957-1.155 2.03 0 .98.28 2.123.84 3.43l8.4 20.86 7.77-20.23c.513-1.4.77-2.473.77-3.22 0-1.073-.42-1.867-1.26-2.38-.84-.513-2.17-.84-3.99-.98v-1.4c2.473.14 4.433.21 5.88.21z" fill="#000" fill-rule="nonzero" mask="url(#b)"></path>
        </g>
      </svg>

      <div class="m-msc-rewards__status-orchid">
        <div class="content-asset">
          <p class="heading-h4 m-msc-rewards__status-title">作为兰花会员，您将从专用和个性化的优势中受益。</p>
          <div class="m-msc-rewards__status-description">
            <p class="m-msc-rewards__status-description-item text--no-margin">用忠诚度积分对待产品</p>
            <p class="m-msc-rewards__status-description-item text--no-margin">享受兰花特价优惠</p>
          </div>
          <router-link to="/member-club" class="link-with-arrow link-with-arrow--white m-msc-rewards__status-link">了解更多</router-link>
        </div>
      </div>
      <div class="m-msc-rewards__status-gold">
        <div class="content-asset">
          <div class="heading-h4 m-msc-rewards__status-title">作为金牌会员，您将从专用和个性化的优势中受益。</div>
          <ul class="m-msc-rewards__status-description">
            <li class="m-msc-rewards__status-description-item">用忠诚度积分对待产品</li>
            <li class="m-msc-rewards__status-description-item">享受特别的黄金优惠</li>
          </ul>
          <router-link to="/member-club" class="link-with-arrow link-with-arrow--white m-msc-rewards__status-link">了解更多</router-link>
        </div>
      </div>
      <div class="m-msc-rewards__status-platinum">
        <div class="content-asset">
          <div class="heading-h4 m-msc-rewards__status-title">作为白金会员，您将受益于专用的个性化优势</div>
          <ul class="m-msc-rewards__status-description">
            <li class="m-msc-rewards__status-description-item">用忠诚度积分对待产品</li>
            <li class="m-msc-rewards__status-description-item">从白金优惠中受益</li>
          </ul>
          <router-link to="/member-club" class="link-with-arrow link-with-arrow--white m-msc-rewards__status-link">了解更多</router-link>
        </div>
      </div>
      <div class="m-msc-rewards__status-nostatus">
        <div class="content-asset">
          <p class="heading-h4 m-msc-rewards__status-title">法国希思黎致臻坊会员</p>
          <div class="m-msc-rewards__status-description">
          <p class="m-msc-rewards__status-description-item text--no-margin">会员积分礼遇</p>
          <p class="m-msc-rewards__status-description-item text--no-margin">悦享专属惊喜</p>
          </div>
          <router-link to="/member-club" class="link-with-arrow link-with-arrow--white m-msc-rewards__status-link">了解更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import types from '@/store/types';
import api from '@/utils/api';

export default {
  name: "Club",
  created() {
    if (this.isLogin && !this.$store.state.userFullInfo) {
      this.loadSource();
    }
  },
  methods: {
    loadSource() {
      api[types.GET_ACCOUNT_INFO]({
        key: 'club'
      }).then(res => {
        if (res.code == 1) {
          let { base_info, customer_level, total_points, shipping_address, benefit_info, coupon_list, order_list, active_info  } = res.data;
          this.$store.commit('saveUserFullInfo', {
            base_info,
            customer_level,
            total_points,
            shipping_address,
            benefit_info,
            coupon_list,
            order_list,
            active_info,
            original_level: res.data.original_level || 0
          });
        } else if (res.code != 2) {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  },
  computed: {
    isLogin() {
      return this.$store.state?.isLogin;
    },
    userFullInfo() {
      return this.$store.state?.userFullInfo || { base_info: this.$store.state.userInfo };
    }
  }
}
</script>

<style lang="scss" scoped>
  .m-msc-rewards { padding: 0 1.125rem 4.375rem; }
  .m-msc-rewards__title { font-size: 1.375rem; }
  .m-msc-rewards__subtitle { margin-bottom: .9375rem; }
  .m-msc-rewards__points-wrapper { margin-bottom: 3.125rem; }
  .m-msc-rewards__points {
    display: flex; margin-bottom: 1.25rem;
    .msc-status { width: 2.625rem; height: 2.625rem; float: left; }
  }
  .m-msc-rewards__points-description {
    float: left;
    padding-left: .625rem;
    color: #000;
    font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif;
    font-size: .75rem;
    align-self: center;
  }
  .m-msc-rewards__points-amount { font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; }
  .m-msc-rewards__points-update { color: #000; }
  .m-msc-rewards__status {
    background: #262626;
    border-radius: .3125rem;
    position: relative;
    padding: 5rem 2rem 4.6875rem;
    margin-bottom: 4.375rem;
    color: #fff;
    .msc-status { position: absolute; top: -2.6875rem; left: 50%; transform: translateX(-50%); width: 5.3125rem; height: 5.3125rem; }
  }
  .m-msc-rewards__status--nostatus {
    .m-msc-rewards__status-orchid, .m-msc-rewards__status-gold, .m-msc-rewards__status-platinum { display: none; }
    .m-msc-rewards__status-nostatus { display: block; }
  }
  .m-msc-rewards__status-title { color: #fff; margin-bottom: 1.5625rem; }
  .m-msc-rewards__status-description { margin-bottom: 1.5625rem; }
  .m-msc-rewards__status-description-item {
    position: relative; margin-left: 1.25rem;
    &:before {
      content: ""; width: .5rem; height: .5rem;
      background: url(../../assets/imgs/icons/checkmark-sm-gold.svg) no-repeat;
      position: absolute; left: -1.25rem; top: .4375rem;
    }
  }
  .m-msc-rewards__status-link {
    float: right; color: #fff;
    &:hover { color: #c4926d; }
  }
  @media screen and (min-width: 48em) {
    .m-msc-rewards { padding: 0 6.875rem 4.375rem; }
    .m-msc-rewards__title { font-size: 1.5625rem; }
    .m-msc-rewards__subtitle { margin-bottom: 1.5625rem; }
    .m-msc-rewards__status { padding: 5rem 3.4375rem 4.6875rem; }
  }

  @media screen and (min-width: 64em) {
    .m-msc-rewards { padding: 4.375rem 3.125rem; }
  }

  @media screen and (min-width: 75em) {
    .m-msc-rewards { padding: 4.375rem 6.25rem; }
    .m-msc-rewards__status { padding: 5rem 6.25rem 4.6875rem; }
  }
</style>